module.exports = __webpack_public_path__ + "media/photography/sectionImage2-672e248f.png";